import styled from '@emotion/styled';
import * as tokens from '@tokens';
import type { PropsOf } from '@emotion/react';

export interface ModalBodyProps extends PropsOf<'div'> {
  /**
   * Styles override.
   */
  className?: string;
}

const StyledModalBody = styled('div')`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
  min-height: ${tokens.spacer.x3};
  overflow-y: auto;
  ${tokens.text('body2')};
`;

export const ModalBody = (props: ModalBodyProps): JSX.Element => (
  <StyledModalBody {...props} />
);
